import styled from "styled-components";
import { theme } from "../../styles/theme";

export const Container = styled.div`
    width: 100%;
    height: auto;

    display: flex;
    align-items: center;
`;

export const Wrapper = styled.div` 
    width: 100%;
    height: 100vh;

    display: flex;

    background-color: #FFFF;

    @media (max-width: 767px) {
        padding: 0 1.5rem;

        gap: 3rem;
        align-items: center;
        flex-direction: column;

        background-color: ${theme.colors.gray.Cinza_1};
    }

    @media (max-width: 478px) {
        padding: 0 1.5rem 1.5rem;

        gap: 1rem;
    }
`;

export const ContainerDescription = styled.div` 
    width: 50%;
    height: 100%;

    display: flex;
    align-items: center;
    justify-content: center;

    background-color: #292E38;

    @media (max-width: 767px) {
        width: 100%;
        height: auto;

        margin-top: 5rem;
        align-items: flex-start;

        background-color: transparent;
    }
`;

export const Description = styled.div` 
    width: auto;
    height: auto;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    >h3{
        margin-top: 3rem;

        text-align: left;
    }

    >p{
        margin: 1rem 0 2rem;

        text-align: left;
    }

    @media (max-width: 767px) {
        max-width: 20.4375rem;

        gap: 0.75rem;
        align-items: center;

        >h3{
            text-align: center;

            font-size: 1.75rem;
            line-height: 2.275rem;
        }

        >p{
            text-align: center;

            font-size: 1rem;
            line-height: 1.6rem;
        }
    }

    @media (max-width: 478px) {
        >h3{
            margin-top: 0;
        }

        >p{
            margin: 0;
        }

        >img:nth-of-type(2){
            height: auto;
            width: 13.438rem;
        }
    }
`;

export const ContainerForm = styled.div` 
    width: 50%;
    height: auto;
 
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    background-color: #FFFFFF;

    @media (max-width: 767px) {
        width: 100%;

        background-color: transparent;
    }
`;

export const Form = styled.div`
    width: 100%;
    height: auto;
    padding: 2rem;
    max-width: 30.25rem;

    gap: 1.5rem;
    display: flex;
    align-items: flex-end;
    flex-direction: column;

    border-radius: 1.5rem;
    background-color: #FFFFFF;
`

export const FormInvalid = styled.div`
    width: 100%;
    height: auto;
    padding: 2rem;
    max-width: 30.25rem;

    display: flex;
    align-items: center;
    justify-content: center;
    
    border-radius: 1.5rem;
    background-color: #FFFFFF;

    >h6{
        text-align: center;
    }
`;

export const FormButton = styled.button`
    all: unset;

    width: auto;
    height: 1.5rem;
    padding: 0.75rem 2rem;

    gap: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;

    cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};

    border-radius: 10rem;
    background-color: ${({ disabled }) => (disabled ? `${theme.colors.disabled.Fundo_Desabilitado}` : `${theme.colors.green.Verde_AgroReceita}`)}; 

    transition: background-color 0.3s ease, color 0.3s ease; 

    >p{
        cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};

        color: ${({ disabled }) => (disabled ? '#AAAAAA' : '#FFFFFF')};
        
        transition: color 0.3s ease;
    }

    >img{
        height: auto;
        width: 1.25rem;

        transition: filter 0.3s ease; 
        filter: ${({ disabled }) => (disabled ? 'grayscale(100%)' : 'none')};
    }

    &:hover {
        background-color: ${({ disabled }) => (disabled ? `${theme.colors.disabled.Fundo_Desabilitado}` : '#259D57')}; 
    }
`;

export const Loading = styled.div`
  @-webkit-keyframes rotating /* Safari and Chrome */{
    from {
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }
    
  @keyframes rotating {
    from {
        -ms-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -ms-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }

  width: 1.25rem;
  height: 1.25rem;
  position: relative;
  margin: auto;

  background-color: transparent;
  border-top: 1px solid #FFFFFF;
  border-bottom: 1px solid #FFFFFF;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-radius: 50%;
  -webkit-animation: rotating 0.7s linear infinite;
  -moz-animation: rotating 0.7s linear infinite;
  -ms-animation: rotating 0.7s linear infinite;
  -o-animation: rotating 0.7s linear infinite;
  animation: rotating 0.7s linear infinite;
`;

export const LoadingContainer = styled(Loading)`
  width: 3.75rem;
  height: 3.75rem;

  border-top: 1px solid ${theme.colors.green.Bandeira};
  border-bottom: 1px solid ${theme.colors.green.Bandeira};
`;

export const ContainerModalRedirect = styled.div`
    height: auto;
    width: 28.75rem;

    display: flex;
    align-items: center;
    flex-direction: column;

    >h3 {
        text-align: center;
    }

    >p {
        margin: 1.5rem 0;

        text-align: center;
    }

    >a>p{
        padding: 0.75rem 2rem;

        border-radius: 10rem;
        background-color: #2FBB69;
    }

    @media (max-width: 767px) {
        width: 100%;

        >p{
            text-align: center;
        }
    }
`